<template>
  <div>
    <!-- 公共头 -->

    <hhead></hhead>
    <nnav></nnav>

    <div
      class="bgimg"
      :style="{
        overflow: 'hidden',
        padding: '0 60px',
        boxSizing: 'border-box',
      }"
    >
      <div class="msg_box" style="padding: 0 20px;">
        <div class="msglist">
          <h4><span></span> 基本信息</h4>
          <div style="margin-bottom: 20px;position: relative;width: 140px;">
            <el-upload
              class="avatar-uploader"
              :action="this.$store.state.api + '/ad/upload/upload_file'"
              :show-file-list="false"
              name="file"
              accept="image/png, image/jpeg"
              :on-success="handleAvatarSuccess_logo"
            >
              <img
                v-if="user.selfImage"
                style="width: 140px;height: 140px;border-radius: 4px;object-fit: cover;"
                :src="this.$store.state.api + user.selfImage"
                class="avatar"
              />
              <i
                v-else
                style="color: #dcdfe6;width: 140px;height: 140px;line-height: 140px; border: 1px dashed #dcdfe6;border-radius: 4px;"
                class="el-icon-plus avatar-uploader-icon"
                >形象照片</i
              >
              <i
                class="el-icon-camera"
                style="border-radius: 50%;display: block;background-color: #5B85FF;width: 28px;height: 28px;
              text-align: center;line-height: 28px;font-size: 17px;color: #fff;
              position: absolute;bottom: 0;right: -15px;border: 1px solid #fff;
              "
              ></i>
            </el-upload>
          </div>
          <div class="msg">
            <li>
              <i
                class="el-icon-s-custom
              "
              ></i
              >用户名
            </li>
            <li>{{ this.$store.state.usermsg.name }}</li>
            <b></b>
            <p @click="name_replace">修改</p>
          </div>
          <div class="msg">
            <li><i class="iconfont icon-shouji01"></i>手机号码</li>
            <li>{{ this.$store.state.usermsg.phone }}</li>
            <b></b>
            <p @click="replace">更换</p>
          </div>
          <div class="msg">
            <li><i class="iconfont icon-mima"></i>登录密码</li>
            <li>******</li>
            <b></b>
            <p @click="pwd_replace">修改</p>
          </div>
          <div class="msg">
            <li><i class="iconfont icon-zhanghaozhuxiao"></i>账号注销</li>
            <b></b>
            <p @click="cancel_account">注销</p>
          </div>
        </div>

        <!-- <div class="msglist" style="border: 0;">
          <h4><span></span>第三方账户</h4>
          <div class="msg">
            <li><i class="iconfont icon-weixin"></i>微信账号</li>
            <li>未绑定</li>
            <b></b>
            <p @click.stop.prevent="code_show = true" @click="getQRCode()">
              绑定
            </p>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 更换手机号 -->
    <transition name="el-fade-in-linear">
      <div class="phone_shadow" @click="phone_show = false" v-show="phone_show">
        <div class="content" @click.stop.prevent="stop">
          <div class="top">
            <span>更换手机号</span>
            <i
              class="close iconfont icon-close_round_fill_bold
            "
              @click="cancel"
            ></i>
          </div>
          <div class="body">
            <li>
              <div class="error" v-show="phone_error ? true : false">
                {{ phone_error }}
              </div>
              <div class="input">
                <img
                  style="width: 13px;height: 18px;"
                  src="../../../assets/images/login/sj.png"
                  alt=""
                />
                <el-input
                  placeholder="请输入未注册的手机号"
                  v-model="phone"
                  clearable
                  maxlength="11"
                >
                </el-input>
                <!-- <p class="position" v-show="mobile_show">请输入有效的手机号</p> -->
              </div>
              <div class="input">
                <!-- <p v-show=code_msg 
                style="width: 414px;
                font-size: 14px;
                color: #fb4044;
                position: absolute;
                z-index: 10;
                bottom: -30px;left: 0;">验证码错误</p> -->
                <img
                  style="width: 14px;height: 17px;"
                  src="../../../assets/images/login/yzm.png"
                  alt=""
                />
                <el-input
                  maxlength="4"
                  placeholder="请输入图形验证码"
                  v-model="imgcode"
                >
                </el-input>
                <p
                  @click="refreshCode"
                  :style="{
                    position: 'absolute',
                    top: '-5px',
                    right: '-8px',
                    width: '100px',
                    height: '40px',
                    lineHeight: '58px',
                  }"
                >
                  <Sidentify :identifyCode="identifyCode"> </Sidentify>
                </p>
              </div>
              <div class="input">
                <img
                  style="width: 13px;height: 17px;"
                  src="../../../assets/images/login/dx.png"
                  alt=""
                />
                <el-input
                  maxlength="10"
                  placeholder="请输入短信验证码"
                  v-model="msgcode"
                >
                </el-input>
                <span
                  v-if="msgcode1"
                  style="color: #5B85FF;font-size: 14px;"
                  @click="dx_code"
                  >获取短信验证码</span
                >
                <span
                  v-if="!msgcode1"
                  href="javascript:;"
                  :style="{ color: '#4184e1' }"
                  >重新发送({{ count }})</span
                >
              </div>
            </li>
          </div>
          <div class="bottom">
            <!-- <button plain @click="cancel">取消</button> -->
            <button type="primary" @click="submit_p">确定</button>
          </div>
        </div>
      </div>
    </transition>
    <!-- 修改密码 -->
    <transition name="el-fade-in-linear">
      <div class="phone_shadow" @click="pwd_show = false" v-show="pwd_show">
        <div class="content" @click.stop.prevent="stop">
          <div class="top">
            <span>修改密码</span>
            <i
              class="close iconfont icon-close_round_fill_bold
            "
              @click="pwdShow"
            ></i>
          </div>
          <div class="body body1">
            <li>
              <div class="error" v-show="error ? true : false">{{ error }}</div>
              <div class="input">
                <el-input placeholder=" 原密码" show-password v-model="pwd">
                </el-input>
              </div>

              <div class="input">
                <el-input placeholder="新密码" show-password v-model="newpwd">
                </el-input>
              </div>
              <div class="input">
                <el-input
                  placeholder="确认密码"
                  show-password
                  v-model="newpwd_true"
                >
                </el-input>
              </div>
            </li>
          </div>
          <div class="bottom">
            <!-- <button plain @click="pwd_show = false">取消</button> -->
            <button type="primary" @click="submit_pwd">确定</button>
          </div>
        </div>
      </div>
    </transition>
    <!-- 修改用户名 -->
    <transition name="el-fade-in-linear">
      <div class="phone_shadow" @click="name_show = false" v-show="name_show">
        <div class="content name_content" @click.stop.prevent="stop">
          <div class="top">
            <span>修改用户名</span>
            <i
              class="close iconfont icon-close_round_fill_bold
            "
              @click="nameCancel"
            ></i>
          </div>
          <div class="body body1 name_body">
            <li>
              <div class="error" v-show="name_error ? true : false">
                {{ name_error }}
              </div>
              <div class="input">
                <el-input
                  placeholder="当前用户名"
                  :value="this.$store.state.usermsg.name"
                  disabled
                >
                </el-input>
              </div>
              <div class="input">
                <el-input
                  placeholder="请输入新用户名"
                  clearable
                  v-model="newName"
                >
                </el-input>
              </div>
            </li>
          </div>
          <div class="bottom">
            <button type="primary" @click="submit_name">确定</button>
          </div>
        </div>
      </div>
    </transition>
    <!--  微信二维码 -->
    <transition name="el-fade-in-linear">
      <div
        class="wxCode"
        v-show="code_show"
        @click.stop.prevent="code_show = false"
      >
        <div class="wxBox" @click.stop.prevent="stop">
          <h2 style="margin-bottom: 40px;">微信登录</h2>
          <div class="code"><canvas id="QRCode" /></div>
          <p style="margin-top: 50px;">请使用微信二维码登录</p>
        </div>
      </div>
    </transition>

    <!-- <el-button type="text" size="small" @click="getQRCode()">
          生成二维码
        </el-button> -->

    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import hhead from '../../../components/header/index';
import nnav from '../../../components/nav/index';
import Sidentify from '../../../components/register/sidentify/index';
import QRCode from 'qrcode';

import './style.css';
export default {
  name: 'account',
  components: { hhead, nnav, Sidentify },
  data() {
    return {
      name: this.$store.state.usermsg.name,
      MHeight: document.documentElement.clientHeight - 200 + 'px',
      phone: '', //手机号
      imgcode: '', //图片验证码
      msgcode: '', //短信验证码
      phone_show: false,
      pwd_show: false,
      name_show: false,
      newName: '',
      name_error: '',
      mobile_show: false,
      error: '',
      phone_error: '',
      pwd: '',
      newpwd: '',
      newpwd_true: '',
      code_show: false,
      QRCodeMsg: '', // 生成二维码信息
      msgcode1: true, //获取短信验证码
      user: '',
      identifyCode: '',
      identifyCodes: 'abcdefghijklmnopqrstuvwxyz123456789',
      count: 60,
      code_msg: false,
      imageUrl: '',
      imagePath: '',

      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [7, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [], //页面显示的数组
      // 防止重复提交
      loading: false,
    };
  },
  mounted() {
    this.refreshCode();

    this.msg();
  },
  methods: {
    finish() {
      //   let _this = this;
      //   this.$refs.cropper.getCropBlob((data) => {
      //     let img = window.URL.createObjectURL(data);
      //     this.model = true;
      //     this.modelSrc = img;
      //     let formData = new FormData();
      //     formData.append('file', data, this.fileName);
      //     // console.log(formData);
      // this.$axios
      //   .post('/ad/upload/upload_file', formData)
      //   .then((response) => {
      //     var res = response.data;
      //     if (res.success == 1) {
      //       $('#btn1').val('');
      //       _this.imgFile = '';
      //       _this.headImg = res.realPathList[0]; //完整路径
      //       _this.uploadImgRelaPath = res.relaPathList[0]; //非完整路径
      //       _this.$message({
      //         //element-ui的消息Message消息提示组件
      //         type: 'success',
      //         message: '上传成功',
      //       });
      //     }
      //   });
      // this.$axios({
      //   //
      //   method: 'post',
      //   url: '/ad/upload/upload_file',
      //   body: formData,
      // });
      //   });
      //   this.$refs.cropper.getCropBlob((data) => {
      //     // console.log(window.URL.createObjectURL(data));
      //     // console.log(data);
      //   });
    },
    clear() {
      this.phone = ''; //手机号
      this.imgcode = ''; //图片验证码
      this.msgcode = ''; //短信验证码
      this.pwd = '';
      this.newpwd = '';
      this.newpwd_true = '';
      this.error = '';
      this.phone_error = '';
      this.pwd_show = false;
      this.phone_show = false;
      this.name_show = false;
      this.newName = '';
      this.name_error = '';
    },
    pwdShow() {
      this.clear();
    },
    msg() {
      this.$axios
        .post('/cloud/user_account/getlist', {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.user = res.data.data;
          }
        });
    },
    changeUpload(file, fileList) {
      this.fileinfo = file;

      this.$nextTick(() => {
        this.option.img = file.url;
        this.dialogVisible = true;
      });
    },
    handleAvatarSuccess_logo(res, file) {
      //上传logo
      // console.log(res);
      if (res.code == 200) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imgPath = res.data.filePath;
        // this.fileinfo = file;

        // this.$nextTick(() => {
        //   this.option.img = URL.createObjectURL(file.raw);
        //   this.dialogVisible = true;
        // });
        this.$axios
          .post('/cloud/user_account/change_self_image', {
            apiToken: this.$store.state.usermsg.apiToken,
            SelfImage: res.data.filePath,
          })
          .then((result) => {
            // console.log(result);
            this.msg();
          });
      } else {
        this.$message.error(res.message);
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
      // console.log('当前验证码=', this.identifyCode);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    dx_code() {
      //获取更换手机号验证码
      var that = this;
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        this.phone_error = '';
        // this.mobile_show = false;
        this.$axios
          .post('/user_login_api/sms_code', { type: 2, phone: this.phone })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.msgcode1 = false;
              var Interval = setInterval(function() {
                that.count--;
              }, 1000);

              setTimeout(function() {
                that.msgcode1 = true;
                clearInterval(Interval);
                that.count = 60;
              }, 60000);
            } else {
              this.phone_error = res.data.message;
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      } else {
        this.mobile_show = true;
      }
    },
    cancel() {
      this.clear();
    },
    stop() {},
    replace() {
      this.phone_show = true;
    },
    pwd_replace() {
      this.pwd_show = true;
    },
    name_replace() {
      this.name_show = true;
      this.name_error = '';
      this.newName = '';
    },
    nameCancel() {
      this.name_show = false;
      this.name_error = '';
      this.newName = '';
    },
    submit_name() {
      var trimmed = (this.newName || '').trim();
      if (!trimmed) {
        this.name_error = '请输入新用户名';
        return;
      }
      if (trimmed === this.$store.state.usermsg.name) {
        this.name_error = '新用户名与当前用户名相同';
        return;
      }
      this.$axios
        .post('/cloud/user_account/change_name', {
          apiToken: this.$store.state.usermsg.apiToken,
          name: trimmed,
        })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            var tipName =
              (res.data.data && res.data.data.name) ||
              res.data.name ||
              trimmed;
            this.$store.state.usermsg.name = tipName;
            try {
              localStorage.setItem(
                'token',
                JSON.stringify(this.$store.state.usermsg)
              );
            } catch (e) {}
            this.$alert(String('修改成功'), {
              confirmButtonText: '确定',
              type: 'success',
              center: true,
            })
              .then(() => {})
              .catch(() => {});
            this.name_error = '';
            this.clear();
          } else {
            this.name_error = res.data.message;
          }
        })
        .catch(() => {});
    },
    cancel_account() {
      this.$confirm('<div class="logout-msg">' +
                      '<div class="line1">注销提醒</div>' +
                      '<div class="line2">注销后所有数据将被清空，需重新注册，请确认是否注销？</div>' +
                    '</div>', '', {
        confirmButtonText: '确认注销',
        showCancelButton: false,
        type: 'warning',
        center: true,
        customClass: 'logout-confirm',
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          return this.$axios.post('/cloud/user_account/del_customer', {
            apiToken: this.$store.state.usermsg.apiToken,
          });
        })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            localStorage.removeItem('token');
            localStorage.removeItem('res');
            window.location.href = '/';
          } else {
            this.$alert(res.data.message || '注销失败', {
              confirmButtonText: '确定',
              type: 'error',
              center: true,
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch(() => {});
    },
    submit_p() {
      //更换手机号确定
      if (
        /^1[3456789]\d{9}$/.test(this.phone) &&
        this.imgcode &&
        this.msgcode
      ) {
        if (this.imgcode == this.identifyCode) {
          this.code_msg = false;
          if (this.msgcode) {
            this.$axios
              .post('/cloud/user_account/change_phone', {
                apiToken: this.$store.state.usermsg.apiToken,
                mob: this.phone,
                verifyCode: this.msgcode,
              })
              .then((res) => {
                // console.log(res);
                this.tokenInvalid(res);
                if (res.data.code == 200) {
                  this.clear();
                  this.$alert('修改成功', {
                    confirmButtonText: '确定',
                    type: 'success',
                    center: true,
                  })
                    .then(() => {})
                    .catch(() => {});
                } else {
                  this.phone_error = res.data.message;
                }
              })
              .catch((res) => {
                // console.log(err);
              });
          } else {
            this.phone_error = '请填写短信验证码';
          }
        } else {
          this.phone_error = '图片验证码错误';
        }
      } else {
        this.phone_error = '请输入手机号和验证码';
      }
    },
    submit_pwd() {
      //修改密码
      if (this.pwd) {
        if (
          this.newpwd != this.newpwd_true ||
          !this.newpwd ||
          !this.newpwd_true
        ) {
          this.error = '两次密码输入不一致';
          // console.log(123);
        } else {
          this.$axios({
            method: 'post',
            url: '/cloud/user_account/chagne_pwd',
            params: {
              apiToken: this.$store.state.usermsg.apiToken,
              oldPwd: this.pwd,
              newPwd1: this.newpwd,
              newPwd2: this.newpwd_true,
            },
          })
            .then((res) => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.$alert('修改成功', {
                  confirmButtonText: '确定',
                  type: 'success',
                  center: true,
                })
                  .then(() => {})
                  .catch(() => {});
                this.error = '';
                this.clear();
              } else {
                this.error = res.data.message;
              }
            })
            .catch((err) => {
              // console.log(err);
            });
        }
      } else {
        this.error = '原密码不可为空';
      }
    },
    getQRCode() {
      this.QRCodeMsg = 'https://www.baidu.com'; // 生成的二维码为URL地址
    },
  },
  watch: {
    // 通过监听获取数据
    QRCodeMsg(val) {
      // 获取页面的canvas
      var msg = document.getElementById('QRCode');
      // 将获取到的数据（val）画到msg（canvas）上
      QRCode.toCanvas(msg, val, function(error) {
        // console.log(error);
      });
    },
  },
};
</script>
<style scoped>
/* 仅影响 customClass 为 logout-confirm 的确认框 */


</style>



// WEBPACK FOOTER //
// src/view/user/account/index.vue